const toArray = (records) => (Array.isArray(records) ? records : []);

const formatRecordMessages = (records, label) => {
  if (!records.length) {
    return "";
  }

  const formattedRows = records
    .map((record, index) => {
      const sagaId = record?.sagaId ?? `Row-${index + 1}`;
      const message = record?.message ?? "No message provided";
      return `${index + 1}. Saga ID: ${sagaId} - ${message}`;
    })
    .join("\n");

  return label ? `${label}:\n${formattedRows}` : formattedRows;
};

export const buildRecordOperationMessage = (
  response,
  { failureLabel, successLabel }
) => {
  const detailsRoot = response?.data?.details;
  const detailsData = detailsRoot?.data;
  const details =
    (detailsData && typeof detailsData === "object"
      ? detailsData
      : detailsRoot) || {};

  const messageSegments = [
    formatRecordMessages(toArray(details?.errorRecords), failureLabel),
    formatRecordMessages(toArray(details?.successRecords), successLabel),
  ].filter(Boolean);

  return messageSegments.join("\n\n") || response?.data?.message;
};
